<template>
  <div class="config-user-data" ref="tab">
    <el-form
        :model="formData"
        status-icon
        :rules="rulesForm"
        ref="userConfigForm"
        label-width="110px"
        class="demo-ruleForm"
    >
      <el-form-item label="Payment id" prop="payment_service_id" :error="errors.payment_service_id">
        <el-input type="text" v-model="formData.payment_service_id"></el-input>
      </el-form-item>

      <el-form-item label="Permissions" prop="permissions" :error="errors.roles">
        <el-select v-model="userData.roles" placeholder="Select" multiple allow-create>
          <el-option v-for="(item, key) in formatData.roles" :key="key" :label="item" :value="+key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="User Status" prop="userStatus"  :error="errors.status_id">
        <el-select v-model="formData.status_id" placeholder="Select" @change="changeStatus(formData.status_id)">
          <el-option
              v-for="item in formatData.statuses"
              :key="item.id"
              :label="item.title"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Verified">
        <el-radio-group v-model="formData.verified" size="small">
          <el-radio-button label="0">false</el-radio-button>
          <el-radio-button label="1">true</el-radio-button>
        </el-radio-group>
        <el-button class="ml-15" type="primary" icon="el-icon-message" default  size="small" @click="resendVerified()" title="Resend verification email">
          Resend
        </el-button>
      </el-form-item>

      <el-form-item label="Subscribe">
        <el-radio-group v-model="formData.notification" size="small">
          <el-radio-button label="0">off</el-radio-button>
          <el-radio-button label="1">on</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('userConfigForm')">
          Save
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import _ from "lodash"
import html2canvas from 'html2canvas';

export default {
  name: 'ConfigUserData',
  props: {
    isScreenProcess: Boolean,
    isConfigScreenProcess: Boolean,
    userData: Object,
    formatData: Object,
    screenshotPage: HTMLDivElement
  },
  data () {
    return {
      formErrors: {},
      formData: {
        payment_service_id: '',
        roles: [],
        status_id: null,
        verified: 0,
        notification: 0
      },
      rulesForm: {},
    }
  },
  computed: {
    formKeys() {
      return Object.keys(this.formData)
    },
    errors() {
      const copy = {}
      Object.keys(this.formErrors).forEach(key => {
        copy[key] = this.formErrors[key][0]
      })
      return copy
    }
  },
  watch: {
    userData: function (val, oldval) {
      const formData = _.pick(val, this.formKeys)
      this.formData = {...formData}
    },
    isConfigScreenProcess: function (val, oldVal) {
      if (val) {
        setTimeout(() => {
          this.createCanvas();
        }, 4000)

      }
    }
  },
  mounted () {
    const formData = _.pick(this.userData, this.formKeys)
    this.formData = {...formData}
    if (this.isScreenProcess) {
      setTimeout(() => {
        this.createCanvas();
      }, 4000)
    }
    this.userData.roles = this.userData.roles.map(role => role.id);
  },
  methods: {
    async createCanvas () {
      this.screenshotPage.style.overflow = 'visible';
      this.screenshotPage.style.height = 'auto';
      const canvas = await html2canvas(this.screenshotPage, {
        scrollX: 0,
        scrollY: -window.scrollY,
        width: this.screenshotPage.offsetWidth,
        height: this.screenshotPage.scrollHeight,
      });
      const imgURL = {
        url: canvas.toDataURL('image/png'),
        name: 'User Config',
      };

      this.$emit('addNewImage', imgURL);
      this.$emit('toggleReport');
      this.$emit('triggerNextTab', 'reports');
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.formErrors ={}
          this.formData.roles = this.userData.roles;

          if (this.$route.name === 'user-edit') {
            const {response} = await this.$store.dispatch('users/updateUser', {
              data: this.formData,
              id: this.userData.id
            })

            if (response && response.data && response.data.errors) {
              this.formErrors = {...response.data.errors}
            }


          } else if (this.$route.name === 'user-create') {


            this.$store.dispatch('users/createUser', {...this.userData, ...this.formData}).then(()=>{
              this.$router.push({name:'users'})
            })

          }

        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000,
          })
          return false
        }
      })
    },
    // Set user as unverified when status is Inactive
    changeStatus (status_id) {
      if (status_id == 2) {
        this.formData.verified = 0;
      }
    },
    async resendVerified() {
      const {response} = await this.$store.dispatch('users/resendVerification', {
        id: this.userData.id
      })
    }
  },
}
</script>

<style scoped lang="scss">

.ml-15 {
  margin-left: 15px;
}
.mt-15 {
  margin-top: 15px;
}
</style>
